import { render } from "./AlertItem.vue?vue&type=template&id=08c76f70&scoped=true"
import script from "./AlertItem.vue?vue&type=script&lang=js"
export * from "./AlertItem.vue?vue&type=script&lang=js"

import "./AlertItem.vue?vue&type=style&index=0&id=08c76f70&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c76f70"]])

export default __exports__